export const propMiscModals = {
  policia: {
    title: "تسجيل البيانات",
    heading: "سجّل بيانات السلطات المختصة",
    subtitle: "زامن تسجيلات الوصول في عقارك مع السلطات تلقائيًا",
    entityLabel: "اسم الجهة",
    entityPlaceholder: "اختر جهة",
    userLabel: "اسم المستخدم",
    passwordLabel: "كلمة المرور",
    accessError:
      "تحقّق من بيانات الدخول، ويُنصح بعدم المحاولة أكثر من ثلاث مرات وإلا قد يُحظر حسابك.",
    validateBtn: "تحقّق",
    saveBtn: "حفظ البيانات",
    entityRequired: "الجهة مطلوبة",
    usernameRequired: "اسم المستخدم مطلوب",
    passwordRequired: "يجب إدخال كلمة المرور",
    validateError: "حدث خطأ أثناء التحقق من البيانات",
    saveError: "حدث خطأ أثناء حفظ بيانات شرطة الهجرة",
  },
  upgrade: {
    heading: "قم بترقية خطتك لمواصلة إنشاء العقارات",
    message: "مرحبًا! لاحظنا أنك تجاوزت الحد المسموح به من العقارات في خطتك الحالية.",
    button: "ترقية الخطة",
  },
};
